import axios from "axios";
import querystring from "querystring";

const isIbc = () => {
  let ibc = false;
  const contextStr = sessionStorage.getItem("context");
  if (contextStr) {
    const context = JSON.parse(contextStr);
    if (context.hasOwnProperty("ibc")) {
      ibc = context.ibc;
    }
  }
  return ibc;
};

const getComissionaryCode = () => {
  return isIbc() ? "95293" : "37550";
};

const getUserCode = () => {
  return isIbc() ? "WSIBC" : "WSCONS";
};

const getDirectChat = () => {
  return isIbc()
    ? {
        imovel:
          "https://caixaseguradora.secure.force.com/LiveAgentDirectChat?button_id=5731R000000fxdH&",
        veiculo:
          "https://caixaseguradora.secure.force.com/LiveAgentDirectChat?button_id=5731R000000fxdH&",
      }
    : {
        imovel:
          "https://caixaseguradora.secure.force.com/LiveAgentDirectChat?button_id=5731R000000fxciPauLL&",
        veiculo:
          "https://caixaseguradora.secure.force.com/LiveAgentDirectChat?button_id=5731R000000fxcnPauLL&",
      };
};

const api = {
  CODIGO_COMISSIONADO: getComissionaryCode,
  CODIGO_EMPRESA: "1",
  CODIGO_UNIDADE: "9",
  CODIGO_USUARIO: getUserCode,
  RENDA_TOTAL: "0",
  endpoints: {
    TOKEN: "/oauth-end/oauth2/token",
    PRODUCTS:
      "/auto-compra/v2/cotacao/obter_parametros/consorcio/obter-produtos",
    OFFERS: "/auto-compra/v2/cotacao/simular/consorcio",
    OFFERS_DETAILS:
      "/auto-compra/v2/cotacao/obter_parametros/consorcio/obter-detalhes",
    SAVE_CLIENT: "/auto-compra/v3/consorcio/pessoa",
    CIVIL_STATE: "/auto-compra/v1/consorcios/estado/civil",
    PROFESSION: "/auto-compra/v1/consorcios/profissao",
    COUNTRY: "/auto-compra/v1/consorcios/pais",
    ACCESSIBILITY: "/auto-compra/v1/consorcios/acessibilidade",
    CITY: "/rs/v2.0/consorcios/cidades",
    CEP: "/auto-compra/v1/consorcios/cep/{{cep}}",
    DDD: "/auto-compra/v3/consorcio/pessoa/telefone/ddd",
    STATES: "/auto-compra/v1/consorcios/estados",
    NATUREZA_JURIDICA: "/rs/v1.0/consorcios/natureza/juridica",
    RAMO_ATIVIDADE: "/rs/v1.0/consorcios/ramo/atividade",
    PROPOSTA: "/auto-compra/v2/consorcios/proposta",
    LISTA_DOCUMENTOS: "/rs/v1.0/documentos/processos/{{codigo}}",
    DOC_UPLOAD: "/rs/v1.0/documentos/processos/{{codigo}}/upload",
    ASSINATURA:
      "/auto-compra/v3/consorcios/proposta/{{proposta}}/documento/proposta/assinatura",
    DOWNLOAD_BOLETO:
      "/auto-compra/v2/consorcios/proposta/{{codigo}}/documento/boleto",
    DOWNLOAD_PROPOSTA:
      "/rs/v2.0/consorcios/proposta/{{codigo}}/documento/proposta",
    DOWNLOAD_CONTRATO:
      "/rs/v2.0/consorcios/proposta/{{codigo}}/documento/contrato",
    SIMULATION: "/auto-compra/v1/consorcios/lance/simulacao",
    INSURANCE: "/rs/v1.0/consorcios/seguro/prestamista",
    AGE_VALIDATION:
      "/auto-compra/v2/consorcios/proposta/seguro/prestamista/validacao",
    INCOME_VALIDATION: "/auto-compra/v2/consorcios/proposta/renda/validacao",
    DIRECT_CHAT: getDirectChat,
    SAVE_COTATION: "/auto-compra/v2/cotacao/consorcio",
    USER_XML: "/rs/v1.0/ibc/usuario/informacao/{{token}}",
  },

  get: (endpoint, urlParams, queryParams, config) => {
    let url = urlParams ? api.formatUrl(endpoint, urlParams) : endpoint;
    if (queryParams) {
      url += "?";
      for (const param in queryParams) {
        if (queryParams.hasOwnProperty(param)) {
          url += `${param}=${queryParams[param]}&`;
        }
      }
      url = url.slice(0, -1).replace("%", "%25");
    }
    return axios.get(process.env.REACT_APP_HOST + url, config);
  },
  post: (endpoint, requestBody, urlParams) => {
    const url = urlParams ? api.formatUrl(endpoint, urlParams) : endpoint;
    return axios.post(process.env.REACT_APP_HOST + url, requestBody);
  },
  stringifyPost: (endpoint, requestBody) => {
    return axios.post(
      process.env.REACT_APP_HOST + endpoint,
      querystring.stringify(requestBody),
      {
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
      }
    );
  },
  formatUrl: (url, params) => {
    return url.replace(/\{\{(.*?)\}\}/g, function (match, token) {
      return params[token];
    });
  },
  extend(obj, src) {
    Object.keys(src).forEach(function (key) {
      obj[key] = src[key];
    });
    return obj;
  },
};

export default api;
